import { createReducer } from 'reduxsauce'

const INITIAL_STATE = {}

const ACTION_HANDLERS = {}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
